'use strict'

// Displays the terms of use link. Link text and url are localized
Vue.component('awe-termsofuse', {
  props: {
    visible: {type: Boolean, default: true},
  },
  data: function(){
    return {
      i18n: this.$root.i18n
    }
  },
  template: `
    <a class="termsofuse" v-if="visible" href="https://www.swaven.com/pop-privacy-policy/" target="_blank" :title="i18n.getString('TERMSOFUSE')">
      <slot>{{ i18n.getString('TERMSOFUSE') }}</slot>
    </a>
  `
})
